import fetchRedux from "../../api/fetch_redux";
import axios from "axios";
import { ToastErro } from "../../utils/utils";

export const GET_DADOS_USUARIO = "GET_DADOS_USUARIO";
export const LIMPAR_DADOS_USUARIO = "LIMPAR_DADOS_USUARIO";
export const USUARIO_NOTIFICACOES_MARCAR_LIDA =
  "USUARIO_NOTIFICACOES_MARCAR_LIDA"; // Atualiza o status de uma notificacao marcando como lida
export const USUARIO_NOTIFICACOES_MARCAR_NAO_LIDA =
  "USUARIO_NOTIFICACOES_MARCAR_NAO_LIDA"; //  Atualiza para marcar como lida e nao lida

const ROTAS = ["/notificacoes"];

export const usuarioGetDadosUsuario = () => (dispatch) => {
  axios
    .get("/get_dados_usuario")
    .then((resp) => {
      //
      if (resp.status !== 200) {
        // toast('Não conseguimos recuperar os dados');
        return false;
      }
      // Se for um objeto vazio
      if (!resp.data.nome) {
        // toast('Sem dados para o usuário.');
        return false;
      }
      //
      dispatch({
        type: GET_DADOS_USUARIO,
        data: resp.data,
      });
    })
    .catch((err) => {
      console.log(err);
      // toast('Erro interno ao tentar recuperar dados do Usuario. ');
    });
};
//
export const usuarioLimparDados = () => ({
  type: LIMPAR_DADOS_USUARIO,
});
// Action para marcar uma notificacao como lida
export const usuarioNotificacoesMarcarLidaNaoLida = (obj) => (dispatch) => {
  fetchRedux(
    ROTAS[0],
    "PUT",
    obj,
    (resp) => {
      //
      dispatch({
        type:
          obj.lida === "S"
            ? USUARIO_NOTIFICACOES_MARCAR_LIDA
            : USUARIO_NOTIFICACOES_MARCAR_NAO_LIDA,
        data: resp.data,
      });
    },
    () => {},
    (err) => {
      ToastErro(err);
    }
  );
};
